import { getProviders } from '@/api/providers'

const state = {
  list: [],
  page: 1,
  query: '',
  total: 0
}

const getters = {
  //
}

const mutations = {
  SET_PROVIDERS(state: any, data: any) {
    state.list.splice(0, state.list.length)
    data.forEach((provider: any) => {
      state.list.push(provider)
    })
  },

  SET_TOTAL(state: any, total: any) {
    state.total = total
  },

  SET_PAGE(state: any, page: any) {
    state.page = page
  },

  SET_QUERY(state: any, query: any) {
    state.query = query
  }
}

const actions = {
  async getProviders({ commit, state }: any, params: any) {
    params.page = params.page ?? state.page
    params.query = params.query === undefined ? state.query : params.query
    commit('SET_PAGE', params.page)
    commit('SET_QUERY', params.query)
    const { data } = await getProviders(params)
    commit('SET_PROVIDERS', data.data)
    commit('SET_TOTAL', data.meta.total)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
